import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Offer } from "@/components/Offer";
import { Benefits } from "@/components/Benefits";
import { WhyUs } from "@/components/WhyUs";
import { FormsOfComedy } from "@/components/FormsOfComedy";
import { Testimonials } from "@/components/Testimonials";
import { ContactForm } from "@/components/ContactForm";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { VideoSection } from "@/components/VideoSection";

const Index = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        document.getElementById(location.state.scrollTo)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
      // Clear state to prevent re-scrolling
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  // FAQ JSON-LD Schema
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Ile kosztuje występ kabaretowy dla firmy?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Koszt występu kabaretowego zależy od formy występu, czasu trwania, lokalizacji i liczby artystów. Każdą wycenę przygotowujemy indywidualnie. Skontaktuj się z nami, aby otrzymać bezpłatną wycenę."
        }
      },
      {
        "@type": "Question",
        "name": "Jak zamówić kabaret na event firmowy?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Wystarczy wypełnić formularz kontaktowy na naszej stronie lub zadzwonić pod numer +48 533 333 993. Podczas rozmowy ustalimy termin, formę występu i szczegóły techniczne."
        }
      },
      {
        "@type": "Question",
        "name": "Czy występujecie na terenie całej Polski?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Tak, realizujemy występy kabaretowe na terenie całej Polski. Działamy w Warszawie, Krakowie, Wrocławiu, Poznaniu, Gdańsku, Katowicach i wszystkich innych miastach."
        }
      },
      {
        "@type": "Question",
        "name": "Jakie formy kabaretu oferujecie?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Oferujemy klasyczny występ kabaretowy, stand-up comedy, kabaret interaktywny z udziałem publiczności oraz skecze tematyczne dopasowane do specyfiki firmy i branży."
        }
      },
      {
        "@type": "Question",
        "name": "Czy możecie dostosować występ do tematyki naszej firmy?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Oczywiście! Profesjonalni artyści dostosowują materiał do profilu firmy, branży i specyfiki wydarzenia. Możemy przygotować skecze nawiązujące do Waszej działalności."
        }
      }
    ]
  };

  return (
    <div className="min-h-screen">
      <Helmet>
        <link rel="canonical" href="https://wystepkabaretu.pl/" />
        <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      </Helmet>
      <Navigation />
      <main>
        <Hero />
        <About />
        <Offer />
        <Benefits />
        <WhyUs />
        <FormsOfComedy />
        <VideoSection />
        <Testimonials />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
